import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthRoutes from '@auth/routes/index';
import DashboardRoutes from '@dashboard/routes/index';
import ExamplesRoutes from '@examples/routes/index';
import MainLayout from '@app/views/MainLayout/MainLayout';
import { useAuth } from '@auth/hooks';
import InfoView from '@app/views/InfoView/InfoView';
import SupportView from '@app/views/SupportView/SupportView';
import PrivacyPage from '@features/privacy/views/Privacy';
import { PRIVACY } from '@features/privacy/routes';
import { LEGAL } from '@features/legal/routes';
import LegalPage from '@features/legal/views/Legal';
import { COOKIES } from '@features/cookies/routes';
import CookiesPage from '@features/cookies/views/Cookies';

export default function () {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="*"
          index
          element={
            <Navigate to={user ? 'dashboard/*' : 'auth/login'} replace />
          }
        />

        <Route path="/*" element={<MainLayout />}>
          <Route path="support" element={<SupportView />} />
          <Route path={PRIVACY} element={<PrivacyPage />} />
          <Route path={LEGAL} element={<LegalPage />} />
          <Route path={COOKIES} element={<CookiesPage />} />
          <Route path="info/:route" element={<InfoView />} />
          <Route path="auth/*" element={<AuthRoutes />} />
          <Route path="dashboard/*" element={<DashboardRoutes />} />
          <Route path="examples/*" element={<ExamplesRoutes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
